// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "tbody>.xDkXHzTkJyekuXGULJyr:nth-child(odd){background:rgba(255,255,255,.01)}tbody>.xDkXHzTkJyekuXGULJyr{border-top:.5px solid var(--border_2, #3a394c)}", "",{"version":3,"sources":["webpack://./src/common/components/Table/TableRow/component.module.scss"],"names":[],"mappings":"AAAA,2CACE,gCAAA,CAGF,4BACE,8CAAA","sourcesContent":["tbody > .main:nth-child(odd) {\n  background: rgba(255, 255, 255, 0.01);\n}\n\ntbody > .main {\n  border-top: 0.5px solid var(--border_2, #3a394c);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "xDkXHzTkJyekuXGULJyr"
};
export default ___CSS_LOADER_EXPORT___;
